import {Outlet} from 'react-router-dom';
import {EmployeeSidebar, Topbar} from '../../components';
import styled from 'styled-components';
import {useSocialActivityDataLoader} from '../../hooks';
import {ProfileCompletionBanner} from '../../components/profile-completion-banner/ProfileCompletionBanner';

const Layout = styled.div`
  display: flex;
  height: 100%; /* Full height of the viewport */

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevent scrolling outside the Scene */

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
  }
`;

export const SceneEmployeeHome = () => {
  useSocialActivityDataLoader();
  return (
    <Layout>
      <EmployeeSidebar />
      <Main>
        <Topbar />
        <BannerWrapper>
          <ProfileCompletionBanner />
        </BannerWrapper>
        <Outlet />
      </Main>
    </Layout>
  );
};

const BannerWrapper = styled.div`
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;
